import { TranslationKeys } from './locales';

export const zh: TranslationKeys = {
  common: {
    confirm: '确认',
    cancel: '取消',
    close: '关闭',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    search: '搜索',
    loading: '加载中',
    noData: '没有查询到数据',
    yes: '是',
    no: '否',
    all: '全部',
    yearUnit: '年',
    register: '注册',
    casesUnit: '件',
  },
  
  login: {
    title: '登录',
    id: '用户名',
    password: '密码',
    loginButton: '登录',
    findId: '查找用户名',
    findPassword: '查找密码',
    idPlaceholder: '请输入您的用户名。',
    passwordPlaceholder: '请输入您的密码。',
    keepLoggedIn: '保持登录状态',
    invalidCredentials: '账户信息无效。 <br /> 请检查您的用户名和密码！',
  },
  
  dashboard: {
    title: '仪表板',
    farmMachineryCount: '地图上的农机',
    totalMachinery: '总计',
    unit: '台',
    runningMachinery: '运行中',
    stoppedMachinery: '停止',
    map: '地图',
    list: '列表',
  },
  
  control: {
    title: '农机事故控制',
    farmMachineryOnMap: '地图上的农机',
    searchPlace: '请输入地点或地址',
    placeAddress: '地点/地址',
    normal: '常规',
    cadastral: '地籍图',
    satellite: '卫星',
    eventDate: '事件日期',
    deviceName: '设备名称',
    owner: '所有者',
    status: '状态',
    running: '运行中',
    stopped: '停止',
    noData: '没有查询到数据',
    realtimeDetectionHistory: '实时检测历史',
    farmMachineryList: '农机列表',
    searchedFarmMachinery: '已查询农机',
    resultsPerPage: '每页搜索结果数',
    realtimeOperationStatus: '实时运行状况',
    danger: '危险',
    caution: '注意',
    operating: '运行中',
    notOperating: '未运行',
    rolloverAccident: '翻车事故',
    searchDeviceOwner: '搜索设备名称或所有者名称',
    lastOperation: '上次运行',
    dangerAccident: '危险(翻车事故)',
    deviceList: '设备列表',
    noDeviceFound: '未找到设备',
    selectDetectionType: '选择检测类型',
    selectDeviceType: '选择设备类型',
    totalFarmMachinery: '全部农机',
    checkDate: '请检查日期。',
    selectBothDates: '请选择开始日期和结束日期。',
    group: '组',
    noRecord: '无行驶记录',
    operationRecord: '运行记录',
    user: '用户',
    unlockRolloverStatus: '您要解除车辆翻车状态吗？',
    unlockRolloverContent: '解除后，事故检测状态将正常处理。\n正常处理后无法取消。',
    confirmUnlock: '是，解除',
    openContact: '您要查看联系方式吗？',
    protectingPrivacy: '我们正在保护承租人的个人信息。',
    openLesseeContact: '您要查看承租人的联系方式吗？',
    openContactButton: '查看联系方式',
    protectDevicePrivacy: (item: string) => `为了保护设备 ${item} 的个人信息`,
    enterOfficerName: '请输入查看联系方式的官员的确切姓名。',
    accidentDetected: (minutes: number, seconds: number) => `[ 事故检测后已过去 ${minutes} 分钟 ${seconds} 秒 ]`,
    farmMachineryUsageReport: '农机使用报告',
    accidentDetectionRelease: '解除事故检测',
    accidentDetectionReleaseReason: '请选择解除检测的原因',
    accidentDetectionReleaseReasonDesc: '为了了解检测到的事故情况，\n请选择准确的解除原因。\n解除信息可在[检测历史]中查看。',
    accidentDetectionReleaseReasonDesc2: '为了了解检测到的事故情况，',
    accidentDetectionReleaseReasonDesc3: '请选择准确的解除原因。\n解除信息可在[检测历史]中查看。',
    accidentDetectionReleaseButton: '解除检测',
    accidentOccurred: '发生事故',
    dangerousDriving: '危险驾驶',
    areaExit: '区域离开',
    dangerousAreaEntry: '危险区域进入',
    batteryLow: '电池不足',
    engineAbandonment: '发动机遗弃',
    rolloverAccidentDetected: '已检测到翻车事故。',
    checkUserSafetyImmediately: '请立即检查用户的安全！',
    // 농기계 사용 리포트 관련
    usageReportTitle: (name: string) => `${name}的农机使用报告`,
    closeReportConfirm: '您要关闭报告吗？',
    deviceOperationStartDateMessage: '已检索到设备运行开始日期。',
    currentLocationError: '无法检索当前位置。',
    addressLookupError: '地址查询错误：',
    ownedDeviceList: '拥有的设备列表',
    recentOperationHistory: '最近运行历史',
    operationEndLocation: '运行结束位置：',
    noRecentOperationHistory: '没有最近的运行历史。',
    viewMap: '查看地图',
    viewOperationHistory: '查看运行历史',
    operationRunning: '运行中',
    operationEnd: '运行结束',
    // 소유자 정보 관련
    ownerInfo: '所有者信息',
    ownerLabel: '所有者',
    ownerContact: '所有者联系方式',
    currentLocation: '当前位置',
    contactViewConfirm: '您要查看联系方式吗？',
    contactViewContent: (item: string) => `为了保护设备${item}的隐私，\n请输入操作人员的准确姓名。`,
    contactViewButton: '查看联系方式',
    contactViewPlaceholder: '请输入操作人员的姓名。',
    // 운행 관련
    lastOperationTime: '最后运行',
    noOperationRecord: '无运行记录',
    // 차트 관련
    noDetectionInPeriod: '该期间内无检测记录。',
    pleaseReselectDate: '请重新选择日期。',
    // 기기 정보 모달 관련
    rentalPurpose: '租赁目的',
    // 운행 기록 관련
    travelDistance: '行驶距离',
    farmMachineryVoltage: '农机电压',
    angle: '角度',
    addressUnavailable: '无法确认地址。',
    operationLabel: '运行',
    degreeUnit: '度',
    currentStatus: '当前状态',
    dailyInspectionRequiredMachineryList: '今日需检查农机具列表',
    // 상태 관련
    statusNormal: '正常',
    statusCaution: '注意',
    statusDanger: '危险',
    vehicleRollover: '车辆翻覆',
    // 기기 정보 관련
    deviceType: '设备类型',
    // 감지 종류 (필터용)
    all: '全部',
    vehicleRolloverEvent: '车辆翻覆',
    dangerousDrivingEvent: '危险驾驶',
    engineAbandonmentEvent: '发动机放置',
    areaExitEvent: '使用区域脱离',
    batteryLowEvent: '电池不足',
    theftDetection: '盗窃检测',
    dangerousAreaEntryEvent: '危险区域进入',
    // 기기 종류 (필터용)
    tractor: '拖拉机',
    speedSprayer: '高速喷雾器',
    fourWheelMotorcycle: '四轮摩托车',
    twoWheelMotorcycle: '两轮摩托车',
    oneTonTruck: '1吨卡车',
    walkingManagement: '步行管理机',
    ridingManagement: '乘用管理机',
    agriculturalHighWorkVehicle: '农业用高空作业车',
    agriculturalTransportVehicle: '农业用运输车',
    agriculturalLoader: '农业用装载机',
    ridingWeedCutter: '乘用割草机',
    ridingWeedRemover: '乘用除草机',
    ridingTransplanter: '乘用插秧机',
    fertilizerSpreader: '堆肥撒布机',
    pesticideSpreader: '农药撒布机',
    combine: '联合收割机',
    excavator: '挖掘机',
    cultivator: '耕耘机',
    branchCrusher: '残枝粉碎机',
    etc: '其他',
  },
  
  history: {
    title: '检测历史查询',
    detectionTime: '检测时间',
    eventType: '事件类型',
    deviceName: '设备名称',
    owner: '所有者',
    dateRange: '日期范围',
    from: '开始日期',
    to: '结束日期',
    searchedDetections: '查询到的检测记录',
    detectionNumber: '检测编号',
    deviceType: '设备类型',
    deviceName2: '设备名称',
    detectionDetails: '检测详情',
    detectedDateTime: '检测日期/时间',
    releasedDateTime: '解除日期/时间',
    releaseReason: '解除原因',
    actionTakenBy: '处理人员',
    detectionDetailView: '检测详情查看',
    noDataAvailable: '未找到数据。',
    noLocationData: '无法确定此数据的位置。',
    downloadHistory: '下载历史',
    selectDeviceType: '选择设备类型',
    selectDetectionType: '选择检测类型',
    searchDeviceOwner: '搜索设备名称或所有者名称',
    casesUnit: '例',
    lastOperation: '最后运行',
    distance: '移动距离',
    machineryVoltage: '农机电压',
    currentStatus: '当前状态',
    normal: '正常',
    detectionDetails2: '检测详情',
    detectionDateTime: '检测日期/时间',
    detectionLocation: '检测位置',
    releaseReason2: '解除原因',
    user2: '用户',
    userContact: '用户联系方式',
    guardian: '监护人',
    guardianContact: '监护人联系方式',
    guardianUserRelation: '监护人与用户关系',
    operating: '运行',
    deviceTypeLabel: '设备类型',
  },
  
  manageUser: {
    title: '用户管理',
    userList: '用户列表',
    addUser: '添加用户',
    editUser: '编辑用户',
    deleteUser: '删除用户',
    register: '账户注册',
    permissionManagement: '账户权限管理',
    cancelRegisterTitle: '取消用户注册吗？',
    cancelRegisterContent: '点击确认将重置已输入的内容。',
    userName: '用户名称',
    phone: '电话',
    email: '电子邮件',
    area: '组',
    grade: '等级',
    status: '状态',
    searchUser: '搜索用户ID或名称',
    userAccountInfo: '用户账户信息',
    myAccountInfo: '我的账户信息',
    confirmDelete: '是否要删除此账户？',
    deleteWarning: '用户将无法再使用此账户，\n已删除的账户信息无法恢复。',
    accountName: '账户名',
    userId: 'ID',
    contact: '联系方式',
    address: '地址',
    detailAddress: '详细地址',
    accountCreationDate: '账户创建时间',
    viewDetails: '查看详情',
    viewContactRecord: '查看联系记录',
    recordsFound: '查询到的记录',
    category: '分类',
    contactViewTime: '联系方式查看时间',
    reader: '查看者',
    deleteAccount: '删除账户',
    resetPassword: '重置密码',
    noDataFound: '未找到数据。',
    deleteMessage: '确定要删除吗？',
    searchPlaceholder: '搜索',
    peopleUnit: '人',
    // 附加键
    passwordConfirm: '密码确认',
    maxCharacters: '最多20个字符',
    passwordRequirements: '8个字符以上，包含特殊字符',
    emailExample: '例如 test123@nongcall.com',
    phoneExample: '例如 010-1234-1234 / 031-123-1234',
    postcodeSearch: '查找邮政编码',
    clear: '清除',
    accountNamePlaceholder: '输入使用控制系统的机构名称（最多20个字符）',
    addressPlaceholder: '输入使用控制系统的机构地址',
    userImageAlt: '用户图像',
    // 附加placeholder键
    emailMaxCharacters: '最多50个字符',
    phoneIncludeDash: '输入时包含连字符',
    detailAddressMaxCharacters: '最多100个字符',
    // 权限管理部分
    detectionNotification: '检测情况通知',
    functionManagement: '功能管理',
    dangerAccident: '危险（事故）',
    warningDangerousArea: '注意（进入危险区域）',
    batteryAbnormal: '电池异常',
    areaExit: '使用区域离开',
    detectionRelease: '检测解除处理',
    deviceInfoModify: '设备信息修改',
    // 密码重置
    resetPasswordTitle: '重置密码？',
    resetPasswordContent: '点击确认后密码将被重置。',
    // 联系方式查看弹窗
    openContact: '要查看联系方式吗？',
    protectingPrivacy: '为保护用户的个人信息，\n请输入查看人员的准确姓名。',
    openContactButton: '查看联系方式',
    enterOfficerName: '请输入查看人员姓名。',
    // 联系方式显示
    noContact: '无联系方式',
    viewContact: '查看联系方式',
    // 我的页面模态框
    viewAccountInfo: '要查看账户信息吗？',
    enterPasswordForPrivacy: '为了保护个人信息，\n请输入账户密码。',
    enterPasswordPlaceholder: '请输入密码。',
    confirming: '确认中...',
  },
  
  manageNok: {
    title: '附加接收者管理',
    nokList: '附加接收者列表',
    addNok: '添加附加接收者',
    editNok: '编辑附加接收者',
    deleteNok: '删除附加接收者',
    nokName: '姓名',
    relationship: '关系',
    phone: '电话',
    priority: '优先级',
    // 附加接收者管理页面
    recipientInfo: '附加通知接收者信息',
    recipientContact: '附加接收者联系方式',
    ownerName: '所有者姓名',
    ownerContact: '所有者联系方式',
    accountCreationTime: '账户创建时间',
    viewDetailInfo: '查看详情',
    deleteAccount: '删除账户',
    searchPlaceholder: '搜索接收者ID或姓名',
    registerRecipient: '注册附加接收者',
    sortByName: '按姓名排序',
    sortByContact: '按接收者联系方式排序',
    sortByOwnerName: '按所有者姓名排序',
    sortByOwnerContact: '按所有者联系方式排序',
    sortByRelationship: '按关系排序',
    sortByCreationTime: '按创建时间排序',
    defaultSort: '默认顺序',
    deleteConfirmTitle: '删除此账户？',
    deleteConfirmContent: '此接收者信息将不再可用，\n已删除的信息无法恢复。',
    noDataFound: '未找到数据。',
    // 附加接收者注册/编辑模态框
    registerRecipientTitle: '注册附加接收者',
    registerRecipientSubtitle: '选择所有者',
    editRecipientTitle: '编辑附加接收者',
    editRecipientSubtitle: '选择所有者',
    cancelRegisterTitle: '取消注册？',
    cancelRegisterContent: '所有输入的信息将被清除。',
    selectOwner: '选择所有者',
    nameLabel: '姓名',
    contactLabel: '联系方式',
    ownerLabel: '所有者',
    relationshipLabel: '关系',
    namePlaceholder: '接收者姓名',
    contactPlaceholder: '仅数字（最少10位）',
    relationshipPlaceholder: '输入关系',
    contactMinLength: '联系方式必须至少10位数字。',
    contactOnlyNumbers: '联系方式只能是数字。',
    registerSuccess: '接收者注册成功',
    peopleUnit: '人',
    // 附加接收者详情/编辑模态框
    detailInfoTitle: '接收者详情',
    editInfoTitle: '编辑接收者详情',
    editSuccess: '接收者更新成功',
    cancelEditTitle: '取消编辑接收者？',
    cancelEditContent: '所有输入的信息将被清除。',
    editComplete: '更新完成',
    maxCharacters: '最多20个字符',
    includeDash: '输入时包含连字符。',
  },
  
  manageCustomer: {
    title: '客户管理',
    customerList: '客户列表',
    addCustomer: '添加客户',
    editCustomer: '编辑客户',
    deleteCustomer: '删除客户',
    customerName: '客户名称',
    phone: '电话',
    memo: '备注',
    // 客户管理页面
    ownerInfo: '客户信息',
    ownerNumber: '客户编号',
    contact: '联系方式',
    name: '姓名',
    address: '地址',
    detailAddress: '详细地址',
    group: '组别',
    viewDetailInfo: '查看详情',
    deleteAccount: '删除账户',
    searchPlaceholder: '按客户ID或姓名搜索',
    registerOwner: '注册客户',
    sortByNumber: '按编号排序',
    sortByContact: '按联系方式排序',
    sortByName: '按姓名排序',
    sortByAddress: '按地址排序',
    sortByDetailAddress: '按详细地址排序',
    sortByGroup: '按组别排序',
    defaultSort: '默认排序',
    deleteConfirmTitle: '删除此账户？',
    deleteConfirmContent: '客户将无法再使用此账户，\n已删除的账户信息无法恢复。',
    noDataFound: '未找到数据。',
    peopleUnit: '人',
    casesUnit: '件',
    noAddress: '无地址',
    noGroup: '无组别',
    noDetailAddress: '无详细地址',
    detailAddressLabel: '详细地址',
    // 客户详情模态框
    detailInfoTitle: '客户详情',
    editInfoTitle: '编辑客户',
    ownerName: '客户名称',
    ownerContact: '客户联系方式(ID)',
    password: '密码',
    joinDate: '加入日期',
    other: '其他',
    groupLabel: '组别',
    // 客户修改模态框
    modifyInfoTitle: '编辑客户详情',
    modifyComplete: '编辑完成',
    cancelModifyTitle: '取消客户编辑？',
    cancelModifyContent: '点击确认将重置您输入的内容。',
    invalidPassword: '无效密码。',
    passwordSpaceError: '密码不能包含空格。',
    passwordRequirements: '必须包含至少一个字母、数字和特殊字符，\n且至少8个字符。',
    maxCharacters20: '最多20个字符',
    maxCharacters100: '最多100个字符',
    includeDash: '输入时包含破折号。',
    addressPlaceholder: '地址',
    passwordPlaceholder: '字母、数字、特殊字符，8个字符以上',
    groupSrLabel: '机构',
    // 연락처 관련
    noContact: '无联系方式',
    viewContact: '查看联系方式',
    // 客户注册模态框
    registerInfoTitle: '注册客户',
    registerComplete: '注册',
    cancelRegisterTitle: '取消客户注册？',
    cancelRegisterContent: '点击确认将重置您输入的内容。',
    registerSuccess: '客户注册成功',
    numbersOnly: '请输入数字。',
    otherPlaceholder: '其他输入',
    noDashNumbers: '仅数字，无破折号',
  },
  
  manageMobility: {
    title: '农机管理',
    mobilityList: '农机列表',
    addMobility: '添加农机',
    mobilityName: '农机名称',
    mobilityType: '农机类型',
    owner: '所有者',
    status: '状态',
  },
  
  mobileList: {
    title: '农机管理',
    searchDeviceOwner: '搜索设备名称或所有者名称',
    from: '开始日期',
    to: '结束日期',
    selectDeviceType: '选择设备类型',
    selectDetectionType: '选择检测类型',
    group: '组',
    registerDevice: '注册设备',
    searchedDevices: '已查询设备',
    unit: '单位',
    deviceName: '设备名称',
    deviceType: '设备类型',
    owner: '所有者',
    operationStatus: '运行状态',
    lastOperationDate: '最近运行时间',
    terminalSN: '终端 S/N',
    machineryBattery: '农机 Bat',
    terminalBattery: '终端 Bat',
    testMode: '检查模式',
    deviceDetail: '设备详细信息',
    viewOnMap: '在地图上查看',
    deviceDelete: '删除设备',
    testModeActivate: '要更改模式状态吗？',
    testModeDeactivate: '要解除检查模式吗？',
    testModeActivateContent: '如果更改为检查模式，\n将无法接收该设备的事故通知，\n解除检查模式后可以再次接收。',
    testModeDeactivateContent: '如果解除检查模式，\n该设备可能会发生事故通知。',
    deleteDevice: '要删除该设备吗？',
    deleteDeviceContent: '删除设备后，将无法确认该设备的信息，\n已删除的设备信息无法恢复。',
    confirmDelete: '删除',
    exportInstallHistory: '导出安装历史',
    exportCount: '例',
    noRecord: '无行驶记录',
    inspectionNeeded: '需要终端检查。',
    clipboardCopied: '已复制到剪贴板。',
    noDownloadAvailable: '没有可下载的文件。',
    downloadSuccess: '文件下载成功',
  },
  
  deviceRegister: {
    title: '设备注册',
    deviceName: '设备名称',
    deviceNamePlaceholder: '最多20个字符',
    owner: '所有者',
    ownerPlaceholder: '请选择所有者',
    selectOwner: '所有者',
    deviceType: '设备类型',
    terminalSerialNumber: '终端序列号',
    terminalSerialPlaceholder: '默认8字符 ~ 最多16字符',
    terminalIMEI: '终端 IMEI',
    terminalIMEIPlaceholder: '数字15位',
    numbersOnly: '请输入数字。',
    confirmRegister: '要注册农机吗？',
    confirmRegisterContent: '注册的内容以后可以修改。',
    confirmRegisterButton: '注册',
    cancelRegister: '要取消设备注册吗？',
    cancelRegisterContent: '如果确认，输入的内容将被初始化。',
    checkInput: '请再次检查输入。',
    registerCancel: '取消',
    registerButton: '注册',
    registerLoading: '注册',
    noRegisterButton: '注册',
    ownerRequired: '请选择所有者。',
    ownerError: '无法选择该数据。',
    imageUploadSuccess: '用户图像上传成功',
    imageUploadError: '图像注册过程中发生错误。',
    bulkUploadTitle: '请上传设备信息Excel文件。',
    bulkUploadContent: '请上传编写了设备注册信息的Excel文件。\n为了准确的设备注册，请只使用按照模板编写的文件。',
  },
  
  deviceDetail: {
    title: '设备详细信息',
    titleEdit: '修改设备信息',
    deviceName: '设备名称',
    owner: '所有者',
    ownerPlaceholder: '请选择所有者',
    ownerSelect: '所有者',
    registrationDate: '设备注册时间',
    deviceType: '设备类型',
    terminalSerialNumber: '终端序列号',
    terminalIMEI: '终端 IMEI',
    modifyDevice: '修改',
    modifyComplete: '完成',
    cancelModify: '要取消修改设备信息吗？',
    cancelModifyContent: '如果确认，修改的内容将被初始化。',
    ownerRequired: '请选择所有者。',
    ownerError: '无法选择该数据。',
    numbersOnly: '请输入数字。',
    save: '保存',
    reset: '取消',
    installPhotos: '安装照片',
    overallView: '农机整体外观',
    terminalInstallation: '终端安装外观',
    terminalSerialSticker: '终端序列贴纸',
    powerWiringStatus: '电源布线状态',
    machineryTypePlate: '农机型号标志牌',
    userPhoto: '用户照片',
    noImage: '没有图像。',
  },
  
  eventTypes: {
    accident: '翻车',
    battery: '电池不足',
    dangerous: '进入危险区域',
    userArea: '偏离使用区域',
    emergency: '紧急呼叫',
    keyOn: '闲置',
  },
  
  status: {
    normal: '正常',
    warning: '警告',
    error: '错误',
    running: '运行中',
    stopped: '停止',
    idle: '待机',
  },
  
  navigation: {
    home: '主页',
    accidentControl: '事故控制',
    detectionHistory: '检测历史',
    statistics: '统计',
    notice: '通知',
    management: '管理',
    farmMachineryManagement: '农机管理',
    userAccountManagement: '用户账户管理',
    ownerManagement: '所有者管理',
    additionalRecipientManagement: '额外接收者管理',
    sitemap: '站点地图',
    logout: '登出',
    honorific: '',
  },
  
  notice: {
    title: '通知',
    goBack: '返回列表',
    confirm: '确认',
    edit: '编辑',
    editContent: '编辑内容',
    delete: '删除',
    deleteTitle: '是否要删除通知？',
    deleteContent: '已删除的通知将不会显示给所有者，无法恢复。',
    register: '注册通知',
    noNotice: '没有已注册的通知。',
    previousNotice: '上一通知',
    nextNotice: '下一通知',
    new: '新增',
    web: 'WEB',
    app: 'APP',
    write: '编写通知',
    editTitle: '编辑通知',
    category: '通知类别',
    noticeTitle: '通知标题',
    titlePlaceholder: '输入标题（最多100个字符）',
    cancel: '取消',
    complete: '完成',
    registerConfirm: '是否要注册通知？',
    registerContent: '通知内容可以编辑或删除，\n已注册的通知可以由所有者查看。',
    cancelConfirm: '是否要返回列表？',
    cancelContent: '如果您点击确认，\n至今编写的内容将不会保存。',
    editBreadcrumb: '编辑通知',
    detailBreadcrumb: '通知详情',
    contentPlaceholder: '请输入正文内容（最多2000个字符）',
    imageFormatInfo: '* 可附加的图像文件格式为 png, jpg, jpeg。',
    imageSizeInfo: '* 一个图像文件的大小限制为5MB，最多可附加5个文件。',
    maxLengthExceeded: '超过2000个字符。',
    invalidFileFormat: '请检查文件格式。\n可上传的文件格式为 png, jpg, jpeg。',
    maxImagesExceeded: '最多只能附加5个图像。',
    maxSizeExceeded: '每个图像文件最多限制5MB。',
    confirmTitle: '请检查内容。',
  },
  
  statistics: {
    title: '检测历史统计',
    search: '查询',
    download: '下载',
    invalidPeriod: '请选择7天或更长的期间。',
    noData: '此期间内无记录。\n请重新选择日期。',
    monthView: '按月查看',
    operatedMachinery: '运行的农机',
    totalMachinery: '全部农机',
    dailyDetections: '每日检测历史（例）',
    periodDetections: '期间内检测历史（%）',
    hourlyDetections: '每小时检测历史（例）',
    detectByType: '按类型检测历史',
    detectList: '检测历史列表',
    totalDetections: '总检测历史',
    rolloverDetections: '翻车事故检测历史',
    dangerousDrivingDetections: '危险驾驶检测历史',
    outOfAreaDetections: '使用区域脱轨检测历史',
    batteryAnomalyDetections: '电池异常检测历史',
    ignitionNeglectDetections: '点火疏忽检测历史',
    cases: '例',
    units: '单位',
    selectPeriod: '期间选择',
    selectPeriodPlaceholder: '-- 期间选择 --',
    oneMonth: '1个月',
    threeMonths: '3个月',
    sixMonths: '6个月',
    oneYear: '1年',
    timeUnit: '（单位：小时）',
    monthlyDetections: '每月检测历史（例）',
    dailyView: '按日查看',
    detectionHistory: '检测历史',
    dayOfWeek: ['日', '一', '二', '三', '四', '五', '六'],
    dangerousAreaEntryDetections: '危险区域进入检测历史',
    user: '用户',
    lastOperation: '最后运行',
    noDrivingRecord: '无行驶记录',
  },
};

